import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PhoneInput from 'shared/PhoneInput/PhoneInput.js'
import {Form, FormGroup,Col, Row, Checkbox,  ControlLabel, FormControl, Button} from 'react-bootstrap';
import {getSeller} from 'reducers/reducer_admin_sellers';
import {getUser} from 'reducers/reducer_admin_users';
import Select   from 'react-select'
import formatNumbers  from 'util/formatNumbers';
import config from  '../../../config';
import {v4 as uuidv4}  from 'uuid';
import {makeRequest, dispatchAction, displayMessage}  from 'actions';
import {Link} from 'react-router';
import PayoutScaleEditModal from 'dashboard/sellers/PayoutScaleEditModal';
import {FETCH_SELLER, FETCH_USER, UPDATE_SELLER, UPDATE_USER} from "actions/actionTypes";
var locationsList =  _.map(config.warehouseData, function (item, key) {
     return {value: key, label: _.startCase(key)}
});


class AdminSellerAddEdit extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);


        var stateData = {
            newRecord: this.props.location.pathname.includes('/add') ? true : false,
            userRoleVisible: false,
            currentPayoutScale:{},
        }
        _.extend(stateData, this.prepareSellerData( ))
         this.state =stateData
        this.addRecord = this.addRecord.bind(this);
        this.editRecord = this.editRecord.bind(this);
    }

    componentWillMount() {
         if (!this.state.newRecord) {

            if (typeof this.props.seller == 'undefined') { /* page reload */
              this.getSellerRecord();
            } else{
                this.setState(this.prepareSellerData( this.props.seller))
            }
        } else {
            if (typeof this.props.user == 'undefined') {
                var methodData = {
                    "success_event": FETCH_USER,
                    'endpoint': '/users/' + encodeURIComponent(this.props.params.userID),
                    'not_display_success_message': true,
                };
                this.props.makeRequest({}, methodData).then(res => {

                });
            }
        }
    }
    getSellerRecord() {
     return  this.props.makeRequest({},  {
       'success_event': FETCH_SELLER,
       'endpoint': '/sellers/' + encodeURIComponent(this.props.params.id),
       'not_display_success_message': true,
     }).then(res => {
        this.setState(this.prepareSellerData( res.data));
      });
    }
    prepareSellerData(seller={}) {

        var paymentMethodEmail = ''
        if (_.get(seller, ['PaymentData'], false)) {
            if (seller.PaymentMethod == 'Paypal' || seller.PaymentMethod == 'Venmo' || seller.PaymentMethod == 'Donate') {
                paymentMethodEmail = _.get(seller, ['PaymentData', seller.PaymentMethod, 'email'], '')
            }
        }
         var dataToUpdate = {
            originalSellerData:seller,
            PaymentMethod: _.find(_.map(config.payoutMethodsMap, function (key, value) {
                return {value: value, label: key}
            }), {'value':   _.get(seller, ['PaymentMethod'],'GoodBuyGear')}),
            PaymentData: _.get(seller, ['PaymentData'], {}),
            CustomPayoutScales:seller.CustomPayoutScales || [],
            PaymentMethodEmail: paymentMethodEmail,
            MarketName:_.find(locationsList, {'value': _.get(seller, ['MarketName'], '')}),
            SellerType:_.find(config.sellerTypes, {'value': _.get(seller, ['SellerType'], '')}),
            PhoneNumber:  '+1' +_.get(seller, ['PhoneNumber', 'Number'], ''),
            PhoneNumberNotAvailable:_.isUndefined(_.get(seller, ['PhoneNumber', 'Number'])) ? true:false,
            Payout:_.get(seller, ['Payout'], ''),
            PickupFee:_.get(seller, ['PickupFee'], 0),
             DisplayName:_.get(seller, ['DisplayName'],''),

            InventoryOwnership: _.find(config.inventoryOwnershipMap, {'value': _.get(seller, ['InventoryOwnership'], '')}),
            PartnerData:_.get(seller, ['InventoryOwnership'], '') =='PartnerConsigned'?{
                ProcessCostOptions:_.map(_.get(seller, ['PartnerData','ProcessCostOptions'], []),item=>{
                    return {value:item.Slug, Label:item.Label, Amount:item.Amount,
                        label:item.Label + ' - ' + formatNumbers.formatMoney(item.Amount) }
                }) }:{},
            PickupAddressCity:_.get(seller, ['PickupAddress', 'City'], ''),
            PickupAddressState:_.get(seller, ['PickupAddress', 'State'], ''),
            PickupAddressZip:_.get(seller, ['PickupAddress', 'Zip'], ''),
            SellerProductTags:_.filter(config.sellerProductTags , function (tag) {
                return _.includes(_.get(seller, ['SellerProductTags'],[]),tag.value)
            }),
            PickupAddressStreet:_.get(seller, ['PickupAddress', 'Street'], ''),
        }

       return dataToUpdate
    }


    addRecord(e) {
        e.preventDefault();
        var objectData = this.prepareDataToSave();
        if (!objectData) {
            return
        }
        objectData['UserID'] = this.props.user._id;
        if (!this.props.user) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'User not defined'
            });
        }
        var methodData = {

            type: 'post',
            endpoint: '/sellers',
            messageData: {'#1#': 'Seller'},
            messageCode: 'recordAdded'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            this.props.dispatchAction({seller: [response.data], _id: this.props.user._id}, UPDATE_USER)
            this.context.router.goBack();
        }.bind(this));
    }

    editRecord(e) {
        e.preventDefault();
        const objectData = this.prepareDataToSave();
        if (!objectData) {
            return
        }

        this.saveSellerData(objectData).then(()=>{
          return this.props.displayMessage({
            'messageCode': 'Seller record updated'
          });
        });
    }
    saveSellerData(dataToUpdate) {
     return this.props.makeRequest(dataToUpdate, {
        success_event: UPDATE_SELLER,
        type: 'patch',
        endpoint: '/sellers/' + encodeURIComponent(this.props.seller._id)
      }).then(function (response) {
        return true;
      }.bind(this));
    }
    prepareDataToSave() {
        var self = this,          error = false,objectData = {PickupAddress:{}};
        var messageData = {
            'messageType': 'warning',
            'messageCode': 'errorFieldRequired',
         }
        var fields = [
            {name:'PaymentMethod', path:['PaymentMethod', 'value'], required:true},
            {name:'MarketName',path:['MarketName', 'value'], required:true},
             {name:'SellerType',path:['SellerType', 'value']},
            {name:'PhoneNumber', required:true},
            {name:'Payout', required:true},
            {name:'DisplayName', required:!this.state.newRecord},
            {name:'PickupFee'},

             {name:'InventoryOwnership',path:['InventoryOwnership', 'value']},
            {name:'Warehouse',setPath: 'PickupAddress.State', path:['PickupAddressState'], required:true, messageCode:'errorSellerPickupAddress'},
            {name:'Warehouse',setPath: 'PickupAddress.City', path:['PickupAddressCity'], required:true,messageCode:'errorSellerPickupAddress'},
            {name:'Warehouse',setPath: 'PickupAddress.Street', path:['PickupAddressStreet'], required:true,messageCode:'errorSellerPickupAddress'},
            {name:'Warehouse',setPath: 'PickupAddress.Zip',  path:['PickupAddressZip'], required:true,messageCode:'errorSellerPickupAddress'},

        ]
        if (!this.state.newRecord && this.state.userRoleVisible) {
            fields.push(  {name:'Roles', required:true})
        }

        _.forEach(fields, function (field) {
            if(_.get(self.state, (field.path ? field.path:[field.name]), '') !== ''){
                _.set(objectData, ( field.setPath ? field.setPath:[field.name]), _.get(self.state, field.path ? field.path:[field.name]))
            } else if(field.required){
                 self.props.displayMessage(_.extend(messageData, field.messageCode ? {messageCode:field.messageCode}:{},{ 'messageData': {'#1#': _.startCase(field.name)}}))
                error = true;
                return false;
            }
        });
        if (error){
            return;
        }
        console.log('objectData', objectData  );
        if (isNaN(objectData['Payout'])) {
            self.props.displayMessage(_.extend(messageData, {'messageCode': 'Please, specify valid Payout value'}));
            return false;
        }

          if (!this.state.newRecord && ! objectData['DisplayName'].endsWith('-'+this.props.seller.SellerNumber)) {
            self.props.displayMessage(_.extend(messageData, {'messageCode': 'Display name should end with existing seller number'}));
            return false;
        }

        if (objectData['PaymentMethod'] == 'Paypal' || objectData['PaymentMethod'] == 'Venmo' || objectData['PaymentMethod'] == 'Donate') {

            if (this.state.PaymentMethodEmail == '') {
                self.props.displayMessage(_.extend(messageData, {'messageCode': 'Please, specify your email or username for payment method'}));
                return false;
            }
            objectData['PaymentData'] = {[objectData['PaymentMethod']] : {'email': this.state.PaymentMethodEmail}}
         }
        if (this.state.PhoneNumberNotAvailable) {
            if (this.state.newRecord){
                delete objectData['PhoneNumber']
            }else{
                objectData['PhoneNumber'] = {'Number': 'unset'}
            }

        }else {
            var PhoneNumber = this.state.PhoneNumber.replace(/[^0-9.]/g, "")
            console.log('PhoneNumber 1', PhoneNumber);
            if (PhoneNumber.indexOf('1') === 0) { /* remove country code 1 from the phone number */
                PhoneNumber = PhoneNumber.substring(1);
            }
            if (!_.includes(this.state.PhoneNumber, '+1')) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Phone number code is not valid'
                });
                return false;
            }

            if (this.state.PhoneNumber.length < 9 || PhoneNumber.length > 10) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Phone number is not valid'
                });
                return false;
            }
            if (this.state.PhoneNumber) {
                objectData['PhoneNumber'] = {'Number': PhoneNumber};
            }
        }
        // if (this.state.Payout < 0 || this.state.Payout > 100) {
        //     this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'Payout must from 0 to 100'
        //     });
        //     return false;
        // }

        if (this.state.SellerProductTags) {
            objectData['SellerProductTags'] = _.map(this.state.SellerProductTags, 'value')
        }
       if( _.get(this.state.InventoryOwnership, 'value') == 'PartnerConsigned'){
            if(_.get(this.state.PartnerData,'ProcessCostOptions',[]).length || _.get(this.state.PartnerData,'ProcessCostOptions',[]).length !==_.get(this.state, ['originalSellerData','PartnerData', 'ProcessCostOptions'], []).length  ){
                objectData['PartnerDataToUpdate'] = {
                    ProcessCostOptions: _.map(_.get(this.state.PartnerData, 'ProcessCostOptions', []), item => {
                        return {
                            Amount: item.Amount, Slug: item.value, Label: item.Label
                        }
                    })
                }
            }
       }
        return objectData;
    }
  addEditPayoutScale() {
     const self = this;

    if(this.state.CustomPayoutScales.length) {
     return this.setState({
        currentPayoutScale: this.state.CustomPayoutScales[0]
      });
    }

     this.props.makeRequest({Name:'PayoutCalculationRulesVersion3'}, {
      'endpoint': '/settings',
    }).then(function (res) {
        const settingsRecord = res.data.data[0];
        return  self.setState({
         currentPayoutScale: {
           newRecord:true,
           PayoutScaleID:uuidv4(),
           Rules:settingsRecord.Data.Rules.reverse().map(item => {
             return {...item};
           })
       }});
     });
  }
    changePaymentMethod(selectedOption) {
        var paymentMethodEmail = ''

         if (  _.get(selectedOption, ['value'], '')== 'Paypal' ||  _.get(selectedOption, ['value'], '') == 'Venmo' ||  _.get(selectedOption, ['value'], '') == 'Donate') {
            paymentMethodEmail = _.get(this.props.seller, ['PaymentData', _.get(selectedOption, ['value'], ''), 'email'], '')
         }

        this.setState({
            PaymentMethod:selectedOption,
            PaymentMethodEmail: paymentMethodEmail,
         });
    }
    submitPayoutRules(payoutScaleToUpdate) {
        this.saveSellerData({CustomPayoutScaleToUpdate:payoutScaleToUpdate}).then(()=>{
          this.setState({
            currentPayoutScale: {}
          });
          this.getSellerRecord();
          this.props.displayMessage({
            'messageCode': 'Custom payout scale updated'
          });
        });
      }
      displayPayoutInput() {
        const customPayoutSetting = this.state.CustomPayoutScales.length ? this.state.CustomPayoutScales[0] : false;
        return  <FormGroup>
            <ControlLabel>Payout (%)</ControlLabel>
            {(!this.state.newRecord &&  this.state.DisplayName) &&
              <Link data-testid = 'custom-payout-settings-link' className="left15 cursor-pointer" onClick={this.addEditPayoutScale.bind(this)}
              >{`${customPayoutSetting ? '' : 'Add'} Custom Payout Settings`}
                {customPayoutSetting ?  ` ( ${customPayoutSetting.Active ? 'Active' : 'Inactive'} )` : ''}
              </Link>
            }
            <FormControl type="text"
                         disabled={customPayoutSetting && customPayoutSetting.Active ? true : false}
                         value={customPayoutSetting && customPayoutSetting.Active ? 'Custom' : this.state.Payout }
                         onChange={(e) => this.setState({
                           'Payout': e.target.value
                         })}
                         placeholder="Payout"/>
          </FormGroup>;
      }
    render() {
          if( _.isUndefined(this.state.Payout )){
            return null
        }

         const {UserID = {email:'', firstName:'', lastName:''}} =  this.state.originalSellerData || {};
         return (
            <div >
                {!this.state.newRecord &&
                <h4 className="clearfix bot15">
                    <div className="pull-left"> { UserID.email}</div>
                    <div className="mg-auto "
                         style={{width: 200}}> { `${UserID.firstName}  ${UserID.lastName}` }</div>
                    <div className="pull-right"
                         style={{
                             position: 'relative',
                             top: -15
                         }}> {_.get(this.props, 'seller.UserID.DisplayName')   }</div>
                </h4>
                }
                     <Form onSubmit={this.state.newRecord ? this.addRecord : this.editRecord}>
                         {!this.state.newRecord &&
                         <FormGroup>
                             <ControlLabel>Display Name</ControlLabel>
                             <FormControl type="text"
                                          value={this.state.DisplayName }
                                          onChange={(e) => this.setState({
                                              'DisplayName': e.target.value
                                          })}
                                          placeholder="Display name"/>
                         </FormGroup>
                         }
                       {this.displayPayoutInput()}
                        <FormGroup>
                            <ControlLabel>Type</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable={false}
                                selectedOptions
                                clearable={false}
                                placeholder="Type"
                                options={ config.sellerTypes}
                                onChange={(selectedOptions)=> this.setState({SellerType: selectedOptions})}
                                value={this.state.SellerType }
                            />

                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Market</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable={false}
                                selectedOptions
                                clearable={false}
                                placeholder="Market Name"
                                options={ locationsList}
                                onChange={(selectedOptions)=>{
                                    var data = {MarketName: selectedOptions}
                                    console.log('data', data  );
                                    if(_.get(data.MarketName,'value') && this.state.newRecord && !this.state.PickupAddressState){
                                        data.PickupAddressState =_.get(_.find(config.warehouseData, {MarketName: data.MarketName.value}), 'provinceCode')
                                    }
                                    this.setState(data)
                                }}
                                value={this.state.MarketName }
                            />

                        </FormGroup>
                        <FormGroup className="bot5">
                            <ControlLabel>Pickup address</ControlLabel>
                        </FormGroup>
                        <FormGroup className="left20">
                            <ControlLabel>State code</ControlLabel>
                            <FormControl type="text"
                                         value={this.state.PickupAddressState }
                                         onChange={(e) => this.setState({
                                             'PickupAddressState': e.target.value
                                         })}
                                         placeholder="State code"/>

                        </FormGroup>
                        <FormGroup className="left20">
                            <ControlLabel>City</ControlLabel>
                            <FormControl type="text"
                                         value={this.state.PickupAddressCity }
                                         onChange={(e) => this.setState({
                                             'PickupAddressCity': e.target.value
                                         })}
                                         placeholder="City"/>
                        </FormGroup>
                        <FormGroup className="left20">
                            <ControlLabel>Street</ControlLabel>
                            <FormControl type="text"
                                         value={this.state.PickupAddressStreet }
                                         onChange={(e) => this.setState({
                                             'PickupAddressStreet': e.target.value
                                         })}
                                          placeholder="Street"/>
                        </FormGroup>
                        <FormGroup className="left20">
                            <ControlLabel>Zip code</ControlLabel>
                            <FormControl type="text"
                                         value={this.state.PickupAddressZip }
                                         onChange={(e) => this.setState({
                                             'PickupAddressZip': e.target.value
                                         })}
                                          placeholder="Zip"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Pickup Fee</ControlLabel>
                            <FormControl type="text"
                                         value={  _.get(this.state, ['PickupFee'], '') }
                                         onChange={(e) =>  this.setState({'PickupFee':e.target.value})}
                                         placeholder="Pickup fee"/>
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Cell Phone Number</ControlLabel>


                            <Col xs={12} sm={6} className="pull-right">
                            <ControlLabel className="pull-right cursor-pointer" onClick={(e) =>{
                                this.setState({PhoneNumberNotAvailable: !this.state.PhoneNumberNotAvailable} )}}>Phone number is not available</ControlLabel>
                            <input type="checkbox"   style={{position:'relative', top:1 }}  className="pull-right right10 cursor-pointer " onChange={(e) =>{
                                this.setState({PhoneNumberNotAvailable: !this.state.PhoneNumberNotAvailable} )}}
                                   checked={this.state.PhoneNumberNotAvailable}
                            >

                            </input>
                            </Col>

                                <PhoneInput defaultCountry={'us'}
                                            placeholder=""
                                            onlyCountries={['us']}
                                    //disableCountryCode={true}
                                            onChange={value => {
                                                this.setState({
                                                    PhoneNumber: value
                                                })
                                            }
                                            }
                                            value={_.get(this.state, ['PhoneNumber'], '')}

                                />

                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Inventory Ownership</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable={false}
                                selectedOptions
                                clearable={false}
                                placeholder="Seller or GBG Inventory"
                                options={ config.inventoryOwnershipMap}
                                onChange={(selectedOptions)=> this.setState({InventoryOwnership: selectedOptions})}
                                value={this.state.InventoryOwnership }
                            />
                        </FormGroup>
                         {_.get(this.state.InventoryOwnership, 'value') == 'PartnerConsigned' &&
                             <div>
                         <FormGroup className="bot0">
                             <ControlLabel>Process cost options</ControlLabel>
                             <Row>
                             <Col md={10} sm={10} xs={12} className="bot10">
                             <Select
                                 tabIndex="0"
                                 searchable={false}
                                 selectedOptions
                                 clearable={false}
                                 placeholder=""
                                 multi

                                  options={this.state.PartnerData.ProcessCostOptions}
                                 onChange={(selectedOptions) => this.setState({PartnerData:{
                                     ...this.state.PartnerData,
                                    ProcessCostOptions: selectedOptions
                                 }})}
                                 value={_.get(this.state.PartnerData,'ProcessCostOptions',[]) }
                             />
                             </Col>
                             <Col md={2}  sm={2} xs={12} className="bot10">
                                 <Button className=" btn btn-primary " type="button"
                                          onClick={() =>  {

                                             this.setState({
                                                 PartnerData: {
                                                     ...this.state.PartnerData,
                                                     newProcessCostOption:{
                                                         display:true
                                                     }
                                                 }
                                             })
                                         }
                                         }>
                                     Add new
                                 </Button>
                             </Col>
                             </Row>
                         </FormGroup>
                                 {_.get(this.state.PartnerData, 'newProcessCostOption.display') &&
                                 <Row className="bot15 ">

                                     <Col md={4} xs={6} className="top10">
                                         <FormControl type="text"
                                                      onChange={(e) =>   this.setState({PartnerData:{
                                                          ...this.state.PartnerData,
                                                          newProcessCostOption:{
                                                              ..._.get(this.state.PartnerData,'newProcessCostOption',{}),
                                                              Label:e.target.value
                                                          }
                                                      }})}
                                                      value={_.get(this.state.PartnerData,'newProcessCostOption.Label','') }
                                                      placeholder="Process cost label"/>
                                     </Col>


                                     <Col md={4} xs={6} className="top10">
                                         <FormControl type="number" min="0" max="100"
                                                      onChange={(e) =>   this.setState({PartnerData:{
                                                          ...this.state.PartnerData,
                                                          newProcessCostOption:{
                                                              ..._.get(this.state.PartnerData,'newProcessCostOption',{}),
                                                              Amount:e.target.value
                                                          }
                                                      }})}
                                                      value={_.get(this.state.PartnerData,'newProcessCostOption.Amount','') }
                                                      placeholder="Process cost amount"/>
                                     </Col>
                                     <Col md={4} sm={4} xs={6} className="top10">
                                         <Button className="right10 pull-left btn btn-primary " type="button"
                                                 disabled={!_.get(this.state.PartnerData,'newProcessCostOption.Amount','') || !_.get(this.state.PartnerData,'newProcessCostOption.Label','')  }
                                                 onClick={() =>  {
                                                     if (_.get(this.state.PartnerData,'newProcessCostOption.Amount','') < 0 || _.get(this.state.PartnerData,'newProcessCostOption.Amount','') > 100) {
                                                         return this.props.displayMessage({
                                                             'messageType': 'warning',
                                                             'messageCode': 'Process cost amount must be between 0 and 100',
                                                         });
                                                     }

                                                     var foundItem = _.find(_.get(this.state.PartnerData, 'ProcessCostOptions',[]), item=>{
                                                         return item.value == _.snakeCase(_.get(this.state.PartnerData,'newProcessCostOption.Label',''))
                                                     })
                                                     console.log('foundItem', foundItem  );
                                                     if(foundItem){
                                                         return this.props.displayMessage({
                                                             'messageType': 'warning',
                                                             'messageCode': 'Process cost option with this label already exists',
                                                         });
                                                     }

                                                     this.setState({
                                                         PartnerData: {
                                                             ...this.state.PartnerData,
                                                             newProcessCostOption:{},
                                                             ProcessCostOptions:  _.concat(_.get(this.state.PartnerData, 'ProcessCostOptions',[]), [{
                                                                 value:_.snakeCase(_.get(this.state.PartnerData,'newProcessCostOption.Label','')),
                                                                 Amount:_.get(this.state.PartnerData,'newProcessCostOption.Amount',''),
                                                                 Label:_.get(this.state.PartnerData,'newProcessCostOption.Label',''),
                                                                 'label': _.get(this.state.PartnerData,'newProcessCostOption.Label','') + ' - ' + formatNumbers.formatMoney(_.get(this.state.PartnerData,'newProcessCostOption.Amount',''))
                                                             }])
                                                         }
                                                     })
                                                 }
                                                 }>
                                             Save
                                         </Button>
                                     </Col>

                                 </Row>
                                 }
                             </div>
                         }
                         <FormGroup className=" ">
                         <ControlLabel>Tags used by default</ControlLabel>
                             <Select
                                 multi
                                 clearable={false}
                                 placeholder="Tags"
                                 options={config.sellerProductTags}
                                 onChange={(selectedOptions) => {
                                     console.log('selectedOptions', selectedOptions);
                                     this.setState({
                                         'SellerProductTags': selectedOptions ? selectedOptions : [],
                                     });
                                 }}
                                 value={this.state.SellerProductTags}
                             />
                     </FormGroup>
                        <FormGroup>
                            <ControlLabel>Payment method</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable={false}
                                selectedOptions
                                clearable={false}
                                 options={ _.map(_.omit(config.payoutMethodsMap,  ['Bill.com', 'TriNet']), function (key, value) {
                                     return {value: value, label: key}
                                 })}
                                onChange={this.changePaymentMethod.bind(this)}
                                value={this.state.PaymentMethod }
                            />

                            {_.get(this.state, ['PaymentMethod', 'value'], '') && ( _.get(this.state, ['PaymentMethod', 'value'], '') == "Donate"  || _.get(this.state, ['PaymentMethod', 'value'], '') == 'Paypal' || _.get(this.state, ['PaymentMethod', 'value'], '') == 'Venmo' ) &&
                            <FormGroup className="left20 top10">
                                <FormControl type="text"
                                             value={this.state.PaymentMethodEmail}
                                             onChange={(e) => this.setState({PaymentMethodEmail: e.target.value})}
                                             placeholder={'Payment method email or username'}/>
                            </FormGroup>
                            }
                        </FormGroup>
                         {/*<FormGroup>*/}
                         {/*<ControlLabel style={{position:'relative', top:1}}  >Contractor  </ControlLabel>*/}
                     
                         {/*<input type="checkbox"  className="left15 " onChange={(e) =>{*/}
                             {/*this.setState({Contractor: !this.state.Contractor} )}}*/}
                                {/*checked={this.state.Contractor}*/}
                         {/*>*/}
                         {/*</input>*/}
                     {/*</FormGroup>*/}

                        <FormGroup>
                            <Button className="btn-primary" type="submit">
                                Save
                            </Button>
                        </FormGroup>
                    </Form>
              {!_.isEmpty(this.state.currentPayoutScale) &&
                <PayoutScaleEditModal
                  {...this.props}
                  submitPayoutRules={this.submitPayoutRules.bind(this)}
                  modalTitle={this.state.currentPayoutScale.newRecord ? 'Add custom payout settings' : 'Edit custom payout settings'}
                  onHide={() => this.setState({
                    currentPayoutScale: {}
                  })}
                  currentPayoutScale={this.state.currentPayoutScale}
                  showModal={true}>
                </PayoutScaleEditModal>
              }


            </div >
        );

    }
}

function mapStateToProps(state, props) {
     return {
        seller: getSeller(state, props.params.id),
        user: props.params.userID ? getUser(state, props.params.userID) : false
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSellerAddEdit);
